import { MuiThemeProvider } from '@material-ui/core';
import Loading from 'components/Modal/__LEGACY__/AbrirVotacaoPautaModal/Loading';
import ModalsManager from 'components/Modal/ModalsManager/ModalsManager';
import TopBar from 'components/__SHARED__/TopBar/TopBar';
import { ITopBarMenuItem } from 'components/__SHARED__/TopBar/TopBarMenuItem';
import { AuthContext } from 'context/authContext/AuthContext';
import { useRefInjection } from 'hooks/useRefInjection';
import Routes from 'library/Routes';
import {
  FullHeightContainer,
  ModalManager,
  TooltipManager,
  TopLoader,
  useToastManager,
} from 'plataforma-fundacao-componentes';
import React, {
  Fragment,
  useContext,
  useLayoutEffect,
  useMemo,
  useState,
} from 'react';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { IReducer } from 'store/Reducer';
import styles from './Layout.scss';
import LayoutContext from './LayoutContext';
import { LayoutMuiTheme } from './LayoutMuiTheme';
import { FixedElements } from 'models/layout.model';

const rootClassName = styles.rootClassName;
export interface ILayoutState {
  isMobile: boolean;
  manualRefreshInterval?: NodeJS.Timeout | number | undefined;
  pageMenuItems: ITopBarMenuItem[];
  toolbarReadOnly?: boolean;
  isLoading?: boolean;
  loadingMessage?: string;
  disableNavDrawer?: boolean;
}

export const isMobileMediaQuery: string = '(max-width: 768px)';

export default function Layout() {
  const { auth, modal } = useSelector((state: IReducer) => state);
  const [isMobile, setIsMobile] = useState(
    window.matchMedia(isMobileMediaQuery).matches
  );
  const [pageMenuItems, setPageMenuItems] = useState<any[]>([]);
  const [toolbarReadOnly, setToolbarReadOnly] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [disableNavDrawer, setDisableNavDrawer] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState<string | undefined>();
  const { loading } = useContext(AuthContext);

  const [ToastManager, showToast, clearToasts] = useToastManager({
    verticalPosition: 'top',
    horizontalPosition: 'right',
    animateSize: false,
    marginTop: '12px',
    max: 50,
    pauseOnFocusLoss: true,
    reverse: true,
  });

  useLayoutEffect(() => {
    const onMediaQuery = (event: MediaQueryListEvent) => {
      setIsMobile(event.matches);
    };
    window
      .matchMedia(isMobileMediaQuery)
      .addEventListener('change', onMediaQuery);
    return () => {
      window
        .matchMedia(isMobileMediaQuery)
        .removeEventListener('change', onMediaQuery);
    };
  }, []);

  const loaderProps: React.ComponentProps<typeof TopLoader> = useMemo(() => {
    if (loading) {
      return {
        opened: true,
        status: typeof loading === 'string' ? loading : undefined,
      };
    }

    return {
      opened: false,
    };
  }, [loading]);

  const containerRef = useRefInjection('.full-height-container-row-content');

  return (
    <div className={rootClassName}>
      <LayoutContext.Provider
        value={{
          isMobile,
          isLogged: auth.logged,
          refContainer: containerRef,
          setPageMenuItems: (menuItems?: ITopBarMenuItem[]) =>
            setPageMenuItems(menuItems!),
          pageMenuItems: pageMenuItems,
          setToolbarReadOnly: setToolbarReadOnly,
          headerHeight: pageMenuItems && pageMenuItems.length > 0 ? 84 : 52,
          startLoading: (message?: string) => {
            setIsLoading(true);
            setLoadingMessage(message);
          },
          finishLoading: () => {
            setIsLoading(false);
            setLoadingMessage(undefined);
          },
          setDisableNavDrawer: setDisableNavDrawer,
          disableNavDrawer,
          showToast,
          clearToasts,
        }}
      >
        <MuiThemeProvider theme={LayoutMuiTheme}>
          <FullHeightContainer
            header={
              auth.logged ? (
                <Fragment>
                  <TopBar
                    readOnly={toolbarReadOnly}
                    mostrarSaudacao={!isMobile}
                    disableLeftMenu={disableNavDrawer}
                  />
                  <div id={FixedElements.header} />
                </Fragment>
              ) : undefined
            }
            horizontalPadding={false}
            verticalPadding={false}
            fixedFooter={<div id={FixedElements.footer} />}
          >
            <Routes />
            {isLoading && <Loading text={loadingMessage} />}
          </FullHeightContainer>
          <ModalsManager />
          <ToastContainer />
          <TooltipManager />
          {ToastManager}
          <ModalManager ref={modal.ModalManagerRef} />
          <TopLoader {...loaderProps} />
        </MuiThemeProvider>
      </LayoutContext.Provider>
    </div>
  );
}
